export const generateScreenFromCapture = async (
  { image, instructions },
  { generateScreen, generateState, onScreen, onVariant, onVariantError },
) => {
  const produced = await generateScreen({ image, instructions });
  if (!produced) return null;
  onScreen(produced);
  for (const [index, variant] of (produced.states || []).entries()) {
    try {
      const drawn = await generateState({
        image,
        styleContent: produced.css,
        htmlContent: produced.html,
        conditionField: variant.conditionField || undefined,
        conditionValue: variant.conditionValue || undefined,
        instructions,
      });
      if (drawn) onVariant({ variant, drawn, index });
    } catch (error) {
      onVariantError({ variant, index, error });
    }
  }
  return produced;
};
